import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { getTranslations } from "../Shared/translations";

interface MyProps {
  visible: string;
  onDataChange: (t: any) => any;
  onSave: (t: any) => any;
}

const SaveAs: React.FC<MyProps> = ({ visible, onDataChange, onSave }) => {
  const t = getTranslations();

  const handleClose = () => {
    onDataChange({ settings: "hidden" });
  };

  const handleSave = () => {
    const fileName = sessionStorage.getItem("bestandsnaam");
    onSave(fileName);
    onDataChange({ settings: "hidden" });
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Remove ProjectID - 
    sessionStorage.removeItem("projectId");
    sessionStorage.setItem("bestandsnaam", event.target.value);
  };

  return (
    <Modal show={visible === "saveas"}>
      <Modal.Header closeButton onClick={handleClose}>
        <Modal.Title>
          <h2>{t.saveProject}</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t.projectName}: <br />
        <input
          type="text"
          onChange={handleTextChange}
          defaultValue={sessionStorage.getItem("bestandsnaam") || ""}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSave}>
          {t.save}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveAs;
